import { LmIconFilledMiscVerification, LmIconOutlineMiscVerification } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconStudyResultsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? <LmIconOutlineMiscVerification {...rest} /> : <LmIconFilledMiscVerification {...rest} />;

export default IconStudyResultsCommon;
